import { render, staticRenderFns } from "./Repo.vue?vue&type=template&id=0ba61635&scoped=true"
import script from "./Repo.vue?vue&type=script&lang=js"
export * from "./Repo.vue?vue&type=script&lang=js"
import style0 from "./Repo.vue?vue&type=style&index=0&id=0ba61635&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba61635",
  null
  
)

export default component.exports